import React from 'react';

type BadgeVariant = 'success' | 'danger' | 'warning' | 'info' | 'neutral' | 'premium';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
}

const variantStyles: Record<BadgeVariant, React.CSSProperties> = {
  success: { background: 'var(--green-100)', color: 'var(--green-900)' },
  danger: { background: 'var(--danger-100)', color: 'var(--danger-900)' },
  warning: { background: 'var(--warning-100)', color: 'var(--warning-900)' },
  info: { background: 'var(--blue-100)', color: 'var(--blue-900)' },
  neutral: { background: 'var(--neutral-200)', color: 'var(--neutral-700)' },
  premium: { background: 'var(--purple-50)', color: 'var(--purple-900)' },
};

export const Badge: React.FC<BadgeProps> = ({ variant = 'neutral', children }) => {
  return (
    <span
      style={{
        ...variantStyles[variant],
        padding: '3px 10px',
        fontSize: 12,
        fontWeight: 600,
        borderRadius: 'var(--radius-full)',
        display: 'inline-block',
        textTransform: 'capitalize',
      }}
    >
      {children}
    </span>
  );
};